import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "HeatMap03"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", { d: "M20.25 2.25H3.75C3.35232 2.25046 2.97105 2.40864 2.68984 2.68984C2.40864 2.97105 2.25046 3.35232 2.25 3.75V20.25C2.25046 20.6477 2.40864 21.0289 2.68984 21.3102C2.97105 21.5914 3.35232 21.7495 3.75 21.75H20.25C20.6477 21.7495 21.0289 21.5914 21.3102 21.3102C21.5914 21.0289 21.7495 20.6477 21.75 20.25V3.75C21.7495 3.35232 21.5914 2.97105 21.3102 2.68984C21.0289 2.40864 20.6477 2.25046 20.25 2.25ZM14.25 6.75H9.75V3.75H14.25V6.75ZM14.25 8.25V11.25H9.75V8.25H14.25ZM8.25 8.25V11.25H3.75V8.25H8.25ZM8.25 12.75V15.75H3.75V12.75H8.25ZM9.75 12.75H14.25V15.75H9.75V12.75ZM15.75 11.25V8.25H20.25V11.25H15.75ZM3.75 17.25H8.25V20.25H3.75V17.25ZM15.75 20.25V17.25H20.25V20.25H15.75Z" }, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/HeatMap03.vue"]]);
